(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["terrys-reel"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.treel').forEach(function(root){
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var wrap=root.querySelector('[data-wrap]'), video=root.querySelector('[data-video]');
    var scenes=[].slice.call(root.querySelectorAll('.treel__scene'));
    var cards=[].slice.call(root.querySelectorAll('.treel__card'));
    var panes=[].slice.call(root.querySelectorAll('.treel__pane'));
    var countEl=root.querySelector('[data-count]');
    var TOTAL=750;
    var spans=[{a:0,b:130,t0:0,t1:6},{a:130,b:350,t0:6,t1:12},{a:350,b:610,t0:12,t1:18},{a:610,b:750,t0:18,t1:20}];
    var last={1:-1,2:-1}, raf=null, primed=false;
    wrap.style.height=(TOTAL+100)+'vh';
    function prime(){
      if(primed||!video) return;
      var p=video.play();
      if(p&&p.then){p.then(function(){video.pause();primed=true;}).catch(function(){});}
      else {video.pause();primed=true;}
    }
    if(video){video.addEventListener('loadeddata',prime);document.addEventListener('scroll',prime,{once:true,passive:true});}
    function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
    function swap(key,list,i){
      if(last[key]===i) return;
      last[key]=i;
      list.forEach(function(el,n){el.classList.toggle('is-current',n===i);});
      if(key===1&&countEl) countEl.textContent=('0'+(i+1)).slice(-2);
    }
    function update(){
      raf=null;
      var rect=wrap.getBoundingClientRect();
      var max=wrap.offsetHeight-window.innerHeight;
      var prog=max>0?clamp(-rect.top/max,0,1):0;
      var vh=prog*TOTAL, idx=spans.length-1;
      for(var i=0;i<spans.length;i++){ if(vh<spans[i].b){idx=i;break;} }
      scenes.forEach(function(el,n){el.classList.toggle('is-active',n===idx);});
      var s=spans[idx], local=clamp((vh-s.a)/(s.b-s.a),0,1);
      if(video&&video.readyState>0){
        var t=s.t0+local*(s.t1-s.t0);
        if(Math.abs(video.currentTime-t)>0.03){ try{video.currentTime=t;}catch(e){} }
      }
      if(idx===1&&cards.length) swap(1,cards,Math.min(cards.length-1,Math.floor(local*cards.length)));
      if(idx===2&&panes.length) swap(2,panes,Math.min(panes.length-1,Math.floor(local*panes.length)));
    }
    function onScroll(){ if(!raf) raf=requestAnimationFrame(update); }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
